import Vue from "vue";

Vue.directive("open-mobile-navigation",
    {
        bind(el, binding)
        {
            el.onclick = function(event)
            {
                if (document.querySelector(".mobile-navigation"))
                {
                    if (document.querySelector(".mobile-navigation").classList.contains("open"))
                    {
                        document.querySelector(".mobile-navigation").classList.remove("open");
                        document.querySelector("body").classList.remove("menu-is-visible");
                    }
                    else
                    {
                        document.querySelector(".mobile-navigation").classList.add("open");
                        document.querySelector("body").classList.add("menu-is-visible");
                    }
                }
            };
        }
    });
